const shortPriceFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const longPriceFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const percentFormat = new Intl.NumberFormat("de-DE", {
  style: "percent",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export function formatPriceShort(price: number) {
  return shortPriceFormat.format(price)
}

export function formatPriceLong(price: number) {
  return longPriceFormat.format(price)
}

export function formatPercent(percent: number) {
  return percentFormat.format(percent)
}

export function roundPrice<T extends number | undefined>(price: T): T {
  if (typeof price === "number") {
    return (Math.round(price * 100) / 100) as T
  }
  return price
}
